export default __webpack_public_path__ + "static/media/Recursos_BRAVE-UP_DATA.59b6f3a6.zip";